module.exports = __webpack_public_path__ + "static/media/iitm-logo.bab94352.png";